import { Create, required, SimpleForm, TextInput } from 'react-admin'

const FaqCategoriesCreate = () => {
  return (
    <Create redirect={'/faq-categories'}>
        <SimpleForm>
            <TextInput source="name" fullWidth validate={[required()]} />
        </SimpleForm>
    </Create>
  )
}

export default FaqCategoriesCreate
